import React from "react";
import { Col, Row } from "react-bootstrap";
import chrome from "../../Assets/TechIcons/Google Chrome.svg";
import vsCode from "../../Assets/TechIcons/vscode.svg";
import macOS from "../../Assets/TechIcons/Apple MacOSX.svg";
import postman from "../../Assets/TechIcons/Postman.svg";
import linux from "../../Assets/TechIcons/linux.svg";
function Toolstack() {
  return (
    <Row style={{ justifyContent: "center", paddingBottom: "50px" }}>
      <Col xs={4} md={2} className="tech-icons">
        <img src={vsCode} alt="vsCode" className="tech-icon-images" />
        <div className="tech-icons-text">VS Code</div>
      </Col>
      <Col xs={4} md={2} className="tech-icons">
        <img src={chrome} alt="Chrome" className="tech-icon-images" />
        <div className="tech-icons-text">Google Chrome</div>
      </Col>
      <Col xs={4} md={2} className="tech-icons">
        <img src={macOS} alt="macOS" className="tech-icon-images" />
        <div className="tech-icons-text">MAC OS</div>
      </Col>
      <Col xs={4} md={2} className="tech-icons">
        <img src={linux} alt="Linux" className="tech-icon-images" />        
        <div className="tech-icons-text">Linux</div>
      </Col>
            <Col xs={4} md={2} className="tech-icons">
        <img src={postman} alt="Postman" className="tech-icon-images" />
        <div className="tech-icons-text">Postman</div>
      </Col>
    </Row>
  );
}

export default Toolstack;
